export default "__VITE_ASSET__wqysh5zk__"